import * as React from 'react';
import { IconProps } from '../types';

const IcReturn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M8.833 19 1.5 12l7.333-7 1.711 1.633-4.4 4.2h14.912V6.167H23.5v7H6.144l4.4 4.2L8.834 19Z"
    />
  </svg>
);

export default IcReturn;
